import { render } from "./KpisSection.vue?vue&type=template&id=56e6b4ed&ts=true"
import script from "./KpisSection.vue?vue&type=script&lang=ts"
export * from "./KpisSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__